import { render, staticRenderFns } from "./SourceForm.vue?vue&type=template&id=628e35d0&"
import script from "./SourceForm.vue?vue&type=script&lang=js&"
export * from "./SourceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports